import axios from 'axios'
import baseURL from '@/api/base'
import local from '@/utils/storage'
import { message } from 'ant-design-vue'
const request = axios.create({
    baseURL,
})

async function requestSend(config) {
    const token = local.get('token')
    if (token) {
        config.headers = Object.assign(config.headers, {
            'Authorization': token
        })
    }
    return config
}

async function requestError(err) {
    debugger
    return err
}

request.interceptors.request.use(requestSend, requestError)

async function responseSuccess(res) {
    if (res.data.success) {
        return res.data.data
    }
    message.error(res.data.message)
    return Promise.reject(res.data);
}
async function responseFail(err) {
    debugger
    return err
}

request.interceptors.response.use(responseSuccess, responseFail)

export default request
